import type { LinkField } from '@/types';

import { ModalName } from '../constants';

export function href(link: LinkField) {
    if (!link.type || link.type === 'custom') {
        return link.url ?? '';
    }

    if (link.type === 'reference') {
        return link.reference?.path ?? '';
    }

    if (link.type === 'book-demo') {
        return `#${ModalName.TALK_TO_SALES}`;
    }

    throw new Error(`Unexpected link type: "${link.type}". Unable to render href.`);
}

export function title(link: LinkField): string | undefined {
    if (link.type === 'custom') {
        return link.label;
    }

    if (link.type === 'reference') {
        return (link.reference as any)?.meta?.title ?? link.reference?.title ?? link.label;
    }

    return undefined;
}
